module.exports = __webpack_public_path__ + "img/listen-on-google-play.3a383c48.png";